(function () {
  var timers = new WeakMap();

  function readBool(el, name, fallback) {
    var v = el.getAttribute(name);
    if (v === null) return fallback;
    return v === 'true' || v === '1';
  }

  function readInt(el, name, fallback) {
    var v = parseInt(el.getAttribute(name), 10);
    return isNaN(v) ? fallback : v;
  }

  function initCarousel(root) {
    var carousel = root.querySelector('[data-its-carousel]');
    if (!carousel) return;
    var slides = carousel.querySelectorAll('[data-its-slide]');
    if (slides.length < 2) return;

    var existing = timers.get(carousel);
    if (existing) {
      clearInterval(existing);
      timers.delete(carousel);
    }

    var prev = root.querySelector('[data-its-prev]');
    var next = root.querySelector('[data-its-next]');
    var loop = readBool(carousel, 'data-its-loop', true);
    var autoscroll = readBool(carousel, 'data-its-autoscroll', false);
    var intervalSec = Math.max(1, readInt(carousel, 'data-its-autoscroll-interval', 5));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var index = 0;
    slides.forEach(function (slide, i) {
      if (i === 0) return;
      slide.classList.remove('is-active');
      slide.setAttribute('aria-hidden', 'true');
    });

    function go(target) {
      var n = slides.length;
      var nextIndex;
      if (loop) {
        nextIndex = ((target % n) + n) % n;
      } else {
        if (target < 0 || target > n - 1) return;
        nextIndex = target;
      }
      if (nextIndex === index) return;
      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');
      slides[nextIndex].classList.add('is-active');
      slides[nextIndex].setAttribute('aria-hidden', 'false');
      index = nextIndex;
    }

    function step() {
      var target = index + 1;
      if (!loop && target > slides.length - 1) {
        stop();
        return;
      }
      go(target);
    }

    function start() {
      if (!autoscroll || reduce) return;
      if (timers.get(carousel)) return;
      var id = setInterval(step, intervalSec * 1000);
      timers.set(carousel, id);
    }

    function stop() {
      var id = timers.get(carousel);
      if (id) {
        clearInterval(id);
        timers.delete(carousel);
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        stop();
        go(index - 1);
        start();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        stop();
        go(index + 1);
        start();
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { stop(); go(index - 1); start(); }
      if (event.key === 'ArrowRight') { stop(); go(index + 1); start(); }
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    start();
  }

  function initAll(scope) {
    var sections = (scope || document).querySelectorAll('.image-text-section');
    sections.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.image-text-section');
    if (section) initCarousel(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.image-text-section');
    if (!section) return;
    var carousel = section.querySelector('[data-its-carousel]');
    if (!carousel) return;
    var id = timers.get(carousel);
    if (id) {
      clearInterval(id);
      timers.delete(carousel);
    }
  });
})();
